module.exports = __webpack_public_path__ + "img/nav.f1749e01.jpg";